export default process.env.VUE_APP_SERVER_IP
